<template>
    <div class="page choose-hospital">
        <div class="search">
            <van-search v-model="value" clearable @focus="is_search = true" @clear="is_search = false" @input="onSearch" :placeholder="placeholder" />
        </div>

        <div class="choose-hospital-title">
            {{ title }}
        </div>

        <div class="choose-hospital-content">
            <van-radio-group v-model="searchRadio" v-if="value != ''" checked-color="#d3172e">
                <van-list :border="false">
                    <van-cell clickable @click="changeSearch(index)" v-for="(item,index) in search_hospital" :key="index">
                        <template slot="icon">
                            <van-radio :name="index" />
                        </template>
                        <template slot="title">
                            <span class="choose-hospital-content-title" v-html="item.name"></span>
                        </template>
                    </van-cell>
                    <van-cell clickable @click="addHospital" v-if="!isSchool">
                        <span class="choose-hospital-content-title">没有您所在的医院？<span class="add">点击添加</span></span>
                    </van-cell>
                </van-list>
            </van-radio-group>
            <van-radio-group v-model="radio" v-if="value == ''" checked-color="#d3172e">
                <van-cell clickable @click="change(index)" v-for="(item,index) in hospital" :key="index">
                    <template slot="icon">
                        <van-radio :name="index" />
                    </template>
                    <template slot="title">
                        <span class="choose-hospital-content-title" v-html="item.name"></span>
                    </template>
                </van-cell>
            </van-radio-group>
        </div>

        <div class="choose-hospital-confirm">
            <van-cell class="choose-hospital-confirm-cell">
                <template slot="title">
                    <div class="choose-hospital-confirm-left">已选：</div>
                    <div class="choose-hospital-confirm-content">{{formData.hospital_name}}</div>
                    <van-button class="choose-hospital-confirm-btn" type="danger" @click="chooseHospital()" color="#D3172E" round size="small">确定</van-button>
                </template>
            </van-cell>
        </div>

    </div>
</template>

<script>
    import Interface from "@/util/interface"
    export default {
        name: 'home',
        computed: {
            title() {
                let str = this.isSchool ? '学校列表' : '医院列表'
                return str
            },
            placeholder() {
                let str = this.isSchool ? '搜索' : '搜索添加更多医院'
                return str
            }
        },
        data() {
            return {
                value: "",
                radio: "",
                searchRadio: "",
                hospital: [],
                search_hospital: [],
                formData: {},
                is_search: false,
                loading: false,
                isSchool: false,
                mobile: ''
            }
        },
        methods: {
            onSubmit() {},
            onSearch() {
                if (this.isSchool) {
                    let params = {
                        name: this.value,
                        province_id: this.formData.province_id,
                    }
                    Interface.getData('get', Interface.user.school, params).then((res) => {
                        this.search_hospital = res.data.list
                    })
                } else {
                    let params = {
                        name: this.value,
                        municipality_id: this.formData.municipality_id,
                        user_mobile: this.mobile,
                    }
                    Interface.getData('get', Interface.user.hospital, params).then((res) => {
                        this.search_hospital = res.data.list
                    })
                }

            },
            addHospital() {
                this.$router.push({
                    name: "add-hospital",
                })
            },
            fetch(scene) {
                if (scene === 'hospital') {
                    let params = {
                        municipality_id: this.formData.municipality_id
,
                        name: '',
                        user_mobile: this.mobile,
                    }
                    this.loading = true
                    Interface.getData('get', Interface.user.hospital, params).then((res) => {
                        this.hospital = res.data.list
                        this.init();
                        this.loading = false
                    })
                } else if (scene === 'school') {
                    let params = {
                        province_id: this.formData.province_id,
                        name: '',
                    }
                    this.loading = true
                    Interface.getData('get', Interface.user.school, params).then((res) => {
                        this.hospital = res.data.list
                        this.init();
                        this.loading = false
                    })
                }
            },
            chooseHospital() {
                let formData = JSON.parse(localStorage.getItem('add-info'))
                if (this.is_search) {
                    formData.hospital_name = this.search_hospital[this.searchRadio].name.replace(/<.*?>/ig, '')
                    formData.hospital_id = this.search_hospital[this.searchRadio].id
                    formData.hospital_level_name = this.search_hospital[this.searchRadio].pccm
                } else {
                    formData.hospital_name = this.hospital[this.radio].name
                    formData.hospital_id = this.hospital[this.radio].id
                    formData.hospital_level_name = this.hospital[this.radio].pccm
                }
                localStorage.setItem('add-info', JSON.stringify(formData))
                this.$router.push({
                    name: "add-info"
                })
            },
            change(index) {
                this.radio = index
                this.formData.hospital_name = this.hospital[this.radio].name
            },
            changeSearch(index) {
                this.searchRadio = index
                this.formData.hospital_name = this.search_hospital[this.searchRadio].name.replace(/<.*?>/ig, '')
            },
            init() {
                if (this.hospital.length > 0) {
                    this.hospital.forEach((val, index) => {
                        if (val.id == this.formData.hospital_id) {
                            this.radio = index
                        }
                    })
                }
                console.log('this.radio:', this.radio, this.searchRadio, this.is_search)
            }
        },
        created() {
            let user = JSON.parse(localStorage.getItem('user'))
            this.mobile = user && user.mobile ? user.mobile : ''
            this.formData = JSON.parse(localStorage.getItem('add-info'))
            Interface.getShareInfo(this, "", "", "")
            this.isSchool = this.$route.query && this.$route.query.isSchool == 1 ? true : false
            if (this.isSchool) {
                this.fetch('school')
            } else {
                this.fetch('hospital')
            }

        },
    }
</script>

<style lang="scss">
    @import "./index-new.scss";
</style>


// WEBPACK FOOTER //
// src/views/login/choose-hospital/index-new.vue